export const GET_RESPONSES = "GET_RESPONSES";
export const UPDATE_RESPONSE_QUERY = "UPDATE_RESPONSE_QUERY";
export const GET_RESPONSE = "GET_RESPONSE";
export const GET_FRAUD_STATUS = "GET_FRAUD_STATUS";
export const EXPORT_RESPONSE_DATA = "EXPORT_RESPONSE_DATA";
export const EXPORT_FILTER_RESPONSE_DATA = "EXPORT_FILTER_RESPONSE_DATA";
export const GET_RESPONSE_INFO = "GET_RESPONSE_INFO"